import StorageService from "@infrastructure/Services/StorageService";
import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

const prefix = StorageService.STORAGE_PREFIX;

interface UserCommentedPostsStoreInterface {
    addToCommentedPosts: (
        postId: number | string,
        commentsCount?: number,
    ) => void;
    commentedPosts: { [postId: number]: number };
    hasUserCommentedOnPost: (postId: number | string) => boolean;
    removeFromCommentedPosts: (postId: number | string) => void;
}

export const useUserCommentedPostsStore =
    create<UserCommentedPostsStoreInterface>()(
        persist(
            (set, get) => ({
                addToCommentedPosts: (postId, commentsCount = 1) => {
                    const countToAdd = commentsCount ?? 1;
                    const commentedPosts = get().commentedPosts;
                    commentedPosts[postId] = commentedPosts[postId]
                        ? commentedPosts[postId] + countToAdd
                        : countToAdd;

                    set({ commentedPosts });
                },
                removeFromCommentedPosts: (postId) => {
                    const commentedPosts = get().commentedPosts;
                    commentedPosts[postId] =
                        commentedPosts[postId] > 0
                            ? commentedPosts[postId] - 1
                            : 0;

                    set({ commentedPosts });
                },
                hasUserCommentedOnPost: (postId) =>
                    get().commentedPosts[postId] > 0,
                commentedPosts: {},
            }),
            {
                name: `${prefix}commented-posts`,
                storage: createJSONStorage(() => localStorage),
            },
        ),
    );
